<template>
  <div
    class="plan-card"
    :class="{ highlight: planInfo.tag, 'svip-card': planInfo.type === 'svip' }"
  >
    <div v-if="planInfo.tag" class="card-tag">{{ planInfo.tag }}</div>
    <!-- 主体内容容器 -->
    <div class="card-main">
      <div class="card-head">
        <h3 class="card-title">{{ planInfo.title }}</h3>
        <p class="card-tip">{{ planInfo.tip }}</p>
      </div>
      <div class="price-box">
        <span class="price-symbol">¥</span>
        <span class="price-num">{{ planInfo.price }}</span>
        <span class="price-unit">{{ planInfo.priceUnit }}</span>
      </div>
      <a-button
        block
        size="large"
        class="subscribe-btn"
        :class="btnClass"
        @click="$emit('open-pay', planInfo)"
      >
        {{ planInfo.btnText }}
      </a-button>
      <ul class="feature-list">
        <li v-for="feature in planInfo.featureList" :key="feature">
          <CheckOutlined />
          <span>{{ feature }}</span>
        </li>
      </ul>
    </div>
    <!-- 固定卡片最底部：无值不展示 -->
    <div v-if="planInfo.bottomTip" class="card-bottom-tip">
      {{ planInfo.bottomTip }}
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { CheckOutlined } from "@ant-design/icons-vue";
const props = defineProps(["planInfo"]);
defineEmits(["open-pay"]);

const btnClass = computed(() => {
  const type = props.planInfo.btnType;
  if (type === "primary") return "primary-btn";
  if (type === "purple") return "purple-btn";
  return "default-btn";
});
</script>

<style scoped lang="less">
:root {
  --primary: #1677ff;
  --purple: #9254de;
  --svip-color: #8b5ef7;
  --light-border: #e8ebf2;
  --radius-md: 12px;
  --radius-sm: 8px;
}
.plan-card {
  background: linear-gradient(180deg, #ffffff 0%, #fcfdff 100%);
  box-shadow: 0px 14px 34px 0px rgba(32, 62, 110, 0.06);
  border-radius: 20px 20px 20px 20px;
  border: 1px solid #dce6f8;
  padding: 24px 20px;
  position: relative;
  overflow: visible;
  /* 垂直弹性布局 */
  display: flex;
  flex-direction: column;
  height: 100%;
  // 性价比推荐高亮卡片专属样式
  &.highlight {
    border: 2px solid var(--primary);
    background: linear-gradient(180deg, #ffffff 0%, #f4f9ff 100%);
    box-shadow: 0px 18px 40px 0px rgba(42, 103, 255, 0.12);
  }
  .card-tag {
    position: absolute;
    top: -12px;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(90deg, #2d6fff 0%, #2f83ff 100%);
    color: #fff;
    font-size: 13px;
    padding: 4px 14px;
    border-radius: 16px;
    box-shadow: 0px 6px 12px rgba(47, 111, 255, 0.2);
  }
  /* 中间内容自动填充剩余高度，把底部提示挤到最下方 */
  .card-main {
    flex: 1;
  }
  .card-head {
    margin-bottom: 0px;
    .card-title {
      font-family: AppleSystemUIFont;
      font-size: 20px;
      color: #142649;
      line-height: 26px;
      margin: 0 0 6px;
    }
    .card-tip {
      font-family: Inter, Inter;
      font-weight: 400;
      font-size: 13px;
      color: #62728b;
      line-height: 20px;
      margin: 0;
      /* 统一按两行预留高度，保证三张卡的价格、按钮横向对齐 */
      min-height: 40px;
    }
  }
  .price-box {
    margin-bottom: 24px;
    display: flex;
    align-items: baseline;
    .price-symbol {
      font-size: 20px;
    }
    .price-num {
      font-weight: bold;
      font-size: 46px;
      color: #122343;
      line-height: 46px;
      margin: 0 4px;
    }
    .price-unit {
      font-family: AppleSystemUIFont;
      font-size: 14px;
      color: #43536d;
      line-height: 18px;
    }
  }
  .subscribe-btn {
    height: 44px;
    border-radius: var(--radius-sm);
    margin-bottom: 20px;
    &.primary-btn {
      background: linear-gradient(90deg, #2d6fff 0%, #2f83ff 100%);
      box-shadow: 0px 16px 36px 0px rgba(42, 103, 255, 0.14),
        0px 7px 13px 0px rgba(47, 111, 255, 0.22);
      border-radius: 12px 12px 12px 12px;
      border: 1px solid rgba(0, 0, 0, 0);
      font-family: Inter, Inter;
      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 17px;
      text-shadow: 0px 16px 36px rgba(42, 103, 255, 0.14),
        0px 7px 13px rgba(47, 111, 255, 0.22);
    }
    &.purple-btn {
      background: #ffffff;
      box-shadow: 0px 14px 34px 0px rgba(32, 62, 110, 0.06);
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #d9c8ff;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 14px;
      color: #8b5ef7;
      line-height: 20px;
      text-shadow: 0px 14px 34px rgba(32, 62, 110, 0.06);
    }
    &.default-btn {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 14px;
      color: #2f68ff;
      line-height: 20px;
      background: #ffffff;
      box-shadow: 0px 14px 34px 0px rgba(32, 62, 110, 0.06);
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #8fb2ff;
    }
  }
  .feature-list {
    list-style: none;
    padding: 0;
    margin: 0 0 20px;
    li {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 10px;
      font-size: 12px;
      color: #333;
      /* 默认蓝色勾选背景 */
      :deep(.anticon) {
        font-weight: 600;
        color: #fff;
        background: #2f71ff;
        padding: 4px;
        box-shadow: 0px 14px 34px 0px rgba(32, 62, 110, 0.06);
        border-radius: 50%;
      }
    }
  }
  /* SVIP当前版本卡片 勾选背景改为紫色#8B5EF7 */
  &.svip-card {
    .feature-list li :deep(.anticon) {
      background: #8b5ef7;
    }
  }
  /* 固定卡片最底部，上边自动留空隙 */
  .card-bottom-tip {
    margin-top: auto;
    box-shadow: 0px 14px 34px 0px rgba(32, 62, 110, 0.06);
    border: 1px solid #edf2fa;
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 12px;
    color: #386fe8;
    line-height: 17px;
    padding: 8px;
    text-align: center;
  }
}
</style>
